import type {DeepPartial} from 'utility-types';
import type {UppyMultiDestinationOptions} from '../../lib/multi-destination';
import {
	createS3MultipartOptions,
	type AwsS3MultipartOptions,
} from './createS3MultipartOptions';
import {createTusOptions, type TusOptions} from './createTusOptions';
import {createXHROptions, type XHRUploadOptions} from './createXHROptions';

// TODO: clean up the typing here so we do not need to cast all this

/**
 * Utility to create multi destination options
 * @param multiDestinationOptions overrides
 * @returns Uppy multidestination options
 */
export const createUppyMultiDestinationOptions = (
	multiDestinationOptions: DeepPartial<UppyMultiDestinationOptions>,
): UppyMultiDestinationOptions => {
	const options = {
		...multiDestinationOptions,
	} as DeepPartial<UppyMultiDestinationOptions>;

	if (options.useXHR)
		options.xhrOptions = createXHROptions(
			options.xhrOptions as XHRUploadOptions,
		);

	if (options.useTus)
		options.tusOptions = createTusOptions(options.tusOptions as TusOptions);

	if (options.useS3Multipart)
		options.s3MultipartOptions = createS3MultipartOptions(
			options.s3MultipartOptions as AwsS3MultipartOptions,
		);

	return options as UppyMultiDestinationOptions;
};

export default createUppyMultiDestinationOptions;
